export const OUTCOME_SALES_AD_LIMIT = 150;
